import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';

const EmptyView3 = compose(
    connect(state => {
        return {
            config: state.config,
        };
    }),
    lifecycle({
        componentDidMount() {
            this.props.dispatch({
                type: 'SET_CONFIG',
                config: {
                    layout: 'empty-view-3',
                    navbar: 'light',
                    logo: 'light',
                    topNavigation: 'light',
                },
            });
        },
    }),
);

export default EmptyView3;
